export enum FileTypes {
    IMAGE = 'image',
    AUDIO = 'audio',
    VIDEO = 'video'
}

export enum LogoActions {
    REPLACE = 'replace',
    DELETE = 'delete'
}
